/**
 * RootLayoutSections Component
 * A layout component that stacks children vertically using Bootstrap classes
 */
import React from "react";
import type { RootLayoutSectionsProps } from "./types";

export function RootLayoutSections({
    Stack,
    Sections,
}: RootLayoutSectionsProps) {
    const children = Sections ?? Stack;
    // Ensure children is an array and add keys if missing
    const childrenArray = React.Children.toArray(children || []);

    return (
        <div className="d-flex flex-column w-100">
            {childrenArray.map((child, index) => {
                // If child is already a valid element with a key, return as is
                if (React.isValidElement(child)) {
                    // If it already has a key, return it
                    if (child.key != null) {
                        return child;
                    }
                    // Otherwise clone with a key
                    const key =
                        (child.props as { _id?: string })?._id ||
                        `stack-item-${index}`;
                    return React.cloneElement(child, { key });
                }
                // For non-element children, wrap in a fragment with key
                return <React.Fragment key={`stack-item-${index}`}>{child}</React.Fragment>;
            })}
        </div>
    );
}

export default RootLayoutSections;
